export default function getDeviceTypeFromUA() {
    let device = null;
    if (typeof window !== 'undefined') {
        const { navigator } = window;
        if (typeof navigator !== 'undefined') {
            const { userAgent = '' } = navigator;
            const lowerUa = userAgent.toLowerCase();

            device = 'unknown';
            if (
                lowerUa.match(/windows phone/) ||
                (lowerUa.match(/windows/) && lowerUa.match(/tablet/))
            ) {
                device = 'windowsphone';
            } else if (userAgent.match(/iPad/i) || userAgent.match(/iP(od|hone)/i)) {
                device = 'ios';
            } else if (userAgent.match(/Android/i)) {
                device = "android";
            }
        }
    }
    return device;
}



// WEBPACK FOOTER //
// ./app/lib/util/getDeviceTypeFromUA.js